import * as React from "react";

// CSS & SCSS
import "./assets/fonts/inter.css";
import "./assets/fonts/material.css";
import "./assets/fonts/icofont/icofont.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/sass/styles.scss";

// JS & COMPONENTS
import "./i18n";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "./context/Themes";
import { SidebarProvider } from "./context/Sidebar";
import { LoaderProvider } from "./context/Preloader";
import { TranslatorProvider } from "./context/Translator";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { LoginPage, RegisterPage, ForgotPasswordPage, DeleteUserPage, PrivacyPolicyPage } from "./pages/auth";

import {
    AnalyticsPage, UserListPage, DeletedUserListPage, UserProfilePage, ClinicListPage, ClinicViewPage, DoctorListPage, AdminProfilePage, ViewDoctor, ConsultationListPage, ConsultationviewPage, TreatmentPage, ContentViewComponent, BroadcastViewPage, UserTabularReport, AppointmentReport, ConsultationReport, ManageConsultationPayment, UserAnalyticalReport, AppointmentAnalyticalReport, ConsultationAnalyticalReport, DoctorAnalyticalReport, ContactUsListPage, AppointmentEarningReport, ConsultationEarningReport, AppointmentEarningAnalytical, ConsultationEarningAnalytical, DeletedClinicListPage, DeletedDoctorviewPage,
    ServiceListPage, AppointmentTableComponent, AppointmentviewPage, DownPaymentListPage, ManagePaymentPage
} from "./pages/main";

import { API_URL, APP_PREFIX_PATH } from "./constant/constant";
import LogoutComponent from "./pages/LogoutComponent/LogoutComponent";


const router = createBrowserRouter([

    { path: APP_PREFIX_PATH + "/", element: <LoginPage /> },
    { path: "/delete-user", element: <DeleteUserPage /> },
    { path: APP_PREFIX_PATH + "/delete-user", element: <DeleteUserPage /> },
    { path: APP_PREFIX_PATH + "/delete-my-account", element: <DeleteUserPage /> },
    { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
    { path: APP_PREFIX_PATH + "/privacy-policy", element: <PrivacyPolicyPage /> },
    { path: APP_PREFIX_PATH + "/dashboard", element: <AnalyticsPage /> },
    { path: APP_PREFIX_PATH + "/forgot-password", element: <ForgotPasswordPage /> },
    { path: APP_PREFIX_PATH + "/reset-password", element: <RegisterPage /> },
    { path: APP_PREFIX_PATH + "/logout", element: <LogoutComponent /> },
    { path: APP_PREFIX_PATH + "/manage-users", element: <UserListPage /> },
    { path: APP_PREFIX_PATH + "/deleted-users", element: <DeletedUserListPage /> },
    { path: APP_PREFIX_PATH + "/user-profile/:user_id", element: <UserProfilePage /> },
    { path: APP_PREFIX_PATH + "/manage-clinics", element: <ClinicListPage /> },
    { path: APP_PREFIX_PATH + "/deleted-clinics", element: <DeletedClinicListPage /> },
    { path: APP_PREFIX_PATH + "/clinic-view/:clinic_id", element: <ClinicViewPage /> },
    { path: APP_PREFIX_PATH + "/manage-doctors", element: <DoctorListPage /> },
    { path: APP_PREFIX_PATH + "/doctor-view/:doctor_id", element: <ViewDoctor /> },
    { path: APP_PREFIX_PATH + "/manage-services", element: <ServiceListPage /> },
    { path: APP_PREFIX_PATH + "/manage-appointment", element: <AppointmentTableComponent /> },
    { path: APP_PREFIX_PATH + "/view-appointment/:clinic_doctor_appointment_id", element: <AppointmentviewPage /> },
    { path: APP_PREFIX_PATH + "/manage-appointment-payment", element: <ManagePaymentPage /> },
    { path: APP_PREFIX_PATH + "/manage-consultation-payment", element: <ManageConsultationPayment /> },
    { path: APP_PREFIX_PATH + "/manage-treatment", element: <TreatmentPage /> },
    { path: APP_PREFIX_PATH + "/manage-contactus", element: <ContactUsListPage /> },
    { path: APP_PREFIX_PATH + "/deleted-doctors", element: <DeletedDoctorviewPage /> },

    { path: APP_PREFIX_PATH + "/manage-consultation", element: <ConsultationListPage /> },
    { path: APP_PREFIX_PATH + "/view-consultation/:consultation_id", element: <ConsultationviewPage /> },
    { path: APP_PREFIX_PATH + "/manage-downpayment", element: <DownPaymentListPage /> },
    { path: APP_PREFIX_PATH + "/manage-content", element: <ContentViewComponent /> },
    { path: APP_PREFIX_PATH + "/manage-broadcast", element: <BroadcastViewPage /> },
    { path: APP_PREFIX_PATH + "/user-report", element: <UserTabularReport /> },
    { path: APP_PREFIX_PATH + "/appointment-report", element: <AppointmentReport /> },
    { path: APP_PREFIX_PATH + "/consultation-report", element: <ConsultationReport /> },
    { path: APP_PREFIX_PATH + "/user-analytical-report", element: <UserAnalyticalReport /> },
    { path: APP_PREFIX_PATH + "/appointment-analytical-report", element: <AppointmentAnalyticalReport /> },
    { path: APP_PREFIX_PATH + "/consultation-analytical-report", element: <ConsultationAnalyticalReport /> },
    { path: APP_PREFIX_PATH + "/doctor-analytical-report", element: <DoctorAnalyticalReport /> },
    { path: APP_PREFIX_PATH + "/admin-profile", element: <AdminProfilePage /> },
    { path: APP_PREFIX_PATH + "/appointment-earning", element: <AppointmentEarningReport /> },
    { path: APP_PREFIX_PATH + "/consultation-earning", element: <ConsultationEarningReport /> },
    { path: APP_PREFIX_PATH + "/appointment-earning-analytical", element: <AppointmentEarningAnalytical /> },
    { path: APP_PREFIX_PATH + "/consultation-earning-analytical", element: <ConsultationEarningAnalytical /> },






]);


createRoot(document.getElementById("root")).render(
    <ThemeProvider>
        <LoaderProvider>
            <TranslatorProvider>
                <SidebarProvider>
                    <RouterProvider router={router} />
                </SidebarProvider>
            </TranslatorProvider>
        </LoaderProvider>

    </ThemeProvider>
);